exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-3e1eac84]::-webkit-inner-spin-button,input[data-v-3e1eac84]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-3e1eac84]{-moz-appearance:textfield}.tanpawrap[data-v-3e1eac84]{white-space:nowrap}", ""]);

// exports
